import type { PostHogConfig } from "posthog-js";

export const POSTHOG_API_KEY = import.meta.env.FUZEBOX_POSTHOG_ID;
export const POSTHOG_API_HOST = import.meta.env.FUZEBOX_POSTHOG_HOST;

const isProductionAnalytics =
  import.meta.env.FUZEBOX_POSTHOG_ANALYTICS_ENABLE === "1";

const isCookieConsentGiven: boolean = isProductionAnalytics
  ? (window._iub?.cs?.api.isConsentGiven() ?? false)
  : true;

export const POSTHOG_OPTIONS: Partial<PostHogConfig> = {
  api_host: POSTHOG_API_HOST,
  ui_host: "https://eu.posthog.com",
  defaults: "2026-01-30",
  person_profiles: "identified_only",
  persistence: isCookieConsentGiven ? "localStorage+cookie" : "memory",
  autocapture: isProductionAnalytics,
  rageclick: isProductionAnalytics,
  capture_pageview: isProductionAnalytics ? "history_change" : false,
  disable_session_recording: !isProductionAnalytics,
  disable_surveys: !isProductionAnalytics,
  enable_heatmaps: isProductionAnalytics,
  advanced_disable_feature_flags_on_first_load: true,
};
